var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.909 17.909 0 40 0s40 17.909 40 40-17.909 40-40 40S0 62.091 0 40z",
    fill: "#B9C0C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.264 42.192a2 2 0 010-2.828l2.12-2.121a6 6 0 00-8.484-8.486l-2.122 2.122a2 2 0 11-2.828-2.829l2.121-2.121c3.905-3.905 10.237-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142l-2.121 2.121a2 2 0 01-2.828 0zM40.071 48.556a2 2 0 012.829 2.829l-2.829 2.828c-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.905-10.237 0-14.142l2.828-2.828a2 2 0 012.829 2.828L28.757 42.9a6 6 0 108.486 8.485l2.828-2.829z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.435 33.707a2 2 0 00-2.829 0l-9.9 9.9a2 2 0 002.83 2.828l9.899-9.9a2 2 0 000-2.828z",
    fill: "#fff"
  })));
}
export default SvgCopyLink;